import { Pipe, PipeTransform } from '@angular/core';
import { CategoryInfo } from 'services/application/application.service';
import { TitleCasePipe } from 'pipes/titlecase.pipe';

@Pipe({
    name: 'categoryCabinet',
})
export class CategoryCabinetPipe implements PipeTransform {
    constructor(private titleCasePipe: TitleCasePipe) {}

    transform(value: number, Categories: CategoryInfo[]) {
        const self = this;

        if (value == null) {
            return 'Not Assigned';
        }

        const entry = (Categories || []).find(c => c.CategoryID === value);

        if (!entry || !entry.CabinetMember) {
            return '';
        }

        const fullname = `${self.titleCasePipe.transform(entry.CabinetMember.FirstName)} ${self.titleCasePipe.transform(
            entry.CabinetMember.LastName
        )}`;

        return fullname;
    }
}
